export default [
    {
        path: '/hr/attendances',
        name: 'attendances',
        props: true,
        component: () => import('@/views/hr/attendances/index.vue'),
        meta: {
            pageTitle: 'Attendances',
            breadcrumb: [
                {
                text: 'Attendances',
                active: true,
                },
            ],
        },
    },
    {
        path: '/hr/attendances/:id',
        name: 'detail-attendances',
        props: true,
        component: () => import('@/views/hr/attendances/detail.vue'),
        meta: {
            pageTitle: 'Detail Attendance',
            breadcrumb: [
                {
                text: 'Attendances',
                to: { name: 'attendances' },
                },
                {
                text: 'Detail Attendance',
                active: true,
                },
            ],
        },
    },
]